(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/widgets-campaign/assets/javascripts/frames/mothersDay2025/mothers-day.js') >= 0) return;  svs.modules.push('/modules/widgets-campaign/assets/javascripts/frames/mothersDay2025/mothers-day.js');
"use strict";

const _React = React,
  Fragment = _React.Fragment;
const mothersDay2025Path = "".concat(svs.core.config.data.svsconfig.cdn, "/images/widgets-campaign/mothersDay2025");
const BottomFrame = () => React.createElement("div", {
  className: "mothers-day-bottom-frame-25 row pointer-none u-position-sticky u-bottom-0"
}, React.createElement("div", {
  className: "mothers-day-bottom-layers-25 u-translate-middle-x relative u-left-50 clip col-md-12"
}, React.createElement("img", {
  alt: "Morsdag-ram-nederdel",
  className: "bottom-frame-mothers-day-25 u-translate-middle-x absolute u-bottom-0 u-left-50",
  src: "".concat(mothersDay2025Path, "/morsdag-ram-botten.svg")
})));
const MothersDay = _ref => {
  let children = _ref.children,
    _ref$showBottom = _ref.showBottom,
    showBottom = _ref$showBottom === void 0 ? true : _ref$showBottom;
  return React.createElement(Fragment, null, children, showBottom && React.createElement(BottomFrame, null));
};
setGlobal('svs.widgetsCampaign.frames.mothersDay2025.MothersDay', MothersDay);

 })(window);